export default __webpack_public_path__ + "static/media/fNeutral9.c0c080e2.png";